import { Injectable } from '@angular/core';
import { Headers, RequestMethod, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { HttpHelper } from '../../common/helpers/http.helper';
import { SessionHelper } from '../../common/helpers/session.helper';
import { ModuleNameConstant } from '../../security/module-name.constant';
import { AffiliatePortalInformationDc } from '../models/affiliate/affiliate-portal-information-dc.model';
import { ClientBannerDc } from '../models/affiliate/client-banner-dc.model';
import { ClientPortalLogoDc } from '../models/affiliate/client-portal-logo-dc.model';
import { EmployeeService } from './employee.service';
import { AffiliateGroupUpdateInformation } from '../models/affiliate/affiliate-group-update-information.model';
import { AddVideo } from '../models/add-video.model';
import { Observable, } from 'rxjs';
import { AffiliateNotifications } from '../models/affiliate/affiliate-notifications.model';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { TeamsVideo } from '../models/affiliate/affiliate-teams-video.model';
import { AffiliateMortagePartner } from '../models/affiliate/affiliate-mortage-partner.model';
import { AffiliateEducationalVideoDc, AffiliateFirstAndMostRecentlyVideo } from '../models/affiliate/affiliate-educational-video.model';
import { MyContactReferrals } from '../models/contact/contact-referrals.model';
import { AffiliateNotesDc, AffiliateTasksDc } from '../../affiliate/models/affiliate/affiliate-note-task.model';
import { Subject } from 'rxjs';
import { MyReferralsDc } from '../../affiliate/models/affiliate/my-referrals-dc';
import { AffiliateTypeId } from '../models/affiliate/affiliate-type-master-min-dc.model';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class AffiliateService {

    public affiliatePermission: any;
    private refreshEducationVideo = new Subject();
    public isRefreshEducationVideo = this.refreshEducationVideo.asObservable();
    public contactAffiliate: any = {};

    private contactIdSource = new Subject();
    updatedContactId = this.contactIdSource.asObservable();

    constructor(private _httpHelper: HttpHelper, private employeeService: EmployeeService) {
    }

    public getMortagePartner(ProgramId: Number, IndustryId: Number): Observable<AffiliateMortagePartner[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/affiliatebyprogramandindustryid?ProgramId=" + ProgramId + "&IndustryId=" + IndustryId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getMortagePartnerWithAffiliateId(ProgramId: Number, IndustryId: Number, AffiliateId: Number): Observable<AffiliateMortagePartner[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/affiliatebyprogramandindustryid?ProgramId=" + ProgramId + "&IndustryId=" + IndustryId + "&AffiliateId=" + AffiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public postTeamsVideo(data: TeamsVideo) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatevideo/addupdateaffiliatevideo";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public getTeamsVideo(affiliateId: Number): Observable<TeamsVideo[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatevideo/getaffiliatevideo?AffiliateId=" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public downloadVideo(url: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this._httpHelper.downloadFile(url, reqOption);
    }

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }


    public exportData(affiliateId: string) {
        let headers = new Headers();
        let reqOption = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/myreferrals/exportexcel?AffiliateIdsList=" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public myReferralsexportData(affiliateId: string, firstName: string, lastName: string, contactTypeId: number) {
        let headers = new Headers();
        let reqOption = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/myreferrals/exportexcel?AffiliateIdsList=" + affiliateId + "&firstname=" + firstName + "&lastname=" + lastName + "&contactTypeId=" + contactTypeId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateMessages(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/noteattachment/getaffiliatemessagecommunication/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateNotifications(affiliateId: Number, affiliateData: any, userId: Number): Observable<AffiliateNotifications> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/notifications/getnotifications?AffiliateId=" + affiliateId + "&NotificationTypeId=" +
            affiliateData.NotificationTypeId + "&IsViewed=" + affiliateData.IsViewed + "&UserId=" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateDashboardNotifications(affiliateId: Number, affiliateData: any, userId: Number): Observable<AffiliateNotifications> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/notifications/getnotificationsaffportal?AffiliateId=" + affiliateId + "&NotificationTypeId=" +
            affiliateData.NotificationTypeId + "&IsViewed=" + affiliateData.IsViewed + "&UserId=" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public checkEmailIsInUse(email: string, userId = 0, userType: string = 'Affiliate'): Observable<boolean> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `user/IsEmailAlreadyInUse?Email=${email}&UserId=${userId}&UserType=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // public getAffiliateNotifications(affiliateId: Number): Observable<AffiliateNotifications[]> {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "affiliate/notifications/getnotifications/" + affiliateId;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }

    public MarkAsImportantAffiliateNotifications(updateObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/notifications/markimportant";
        return this._httpHelper.put(environment.APIBaseUrl + url, updateObj, reqOption);
    }

    public MarkAsSeenAffiliateNotifications(updateObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/notifications/updateisviewed";
        return this._httpHelper.put(environment.APIBaseUrl + url, updateObj, reqOption);
    }

    public DeleteAffiliateNotifications(updateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/notifications/delete/" + updateId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public updateContactTaskStatus(updateObj: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affportal/task/markcomplete";
        return this._httpHelper.post(environment.APIBaseUrl + url, updateObj, reqOption);
    }

    public getAffiliateLoginHistory(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/getaffiliatestatusHistories/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addContractVideo(addVideoObject: AddVideo) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatecontractvideo/addupdateaffiliatecontractvideo";
        return this._httpHelper.post(environment.APIBaseUrl + url, addVideoObject, reqOption);
    }

    public getContractVideo(affiliateId: Number, isFromAffiliate: boolean) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatecontractvideo/getaffiliatecontractvideo?id=" + affiliateId + "&IsAffiliateId=" + isFromAffiliate;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateInfomartionById(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/getaffiliatedetailbyid/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    ///////////////////// Get Affiliate list with out search filter//////////////
    public getAffiliateListWithOutSearchFilter() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/crmaffiliatelist/detailswithoutfilter/";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    ///////////////////// Get Affiliate list with advance search filter//////////////
    public getAffiliateListWithAdvanceSearchFilter(affiliateAdvanceSearchDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/crmaffiliatelist/detailswithsearchfilter/";
        return this._httpHelper.post(environment.APIBaseUrl + url, affiliateAdvanceSearchDc, reqOption);
    }


    public getAffiliateNameList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/affiliatelist/";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);

    }



    public getAffiliateInfomartionContactInFileInfo(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/getaffiliateportalinformation/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);

    }

    public addUpdateAffiliate(addaffiliateInformation: any, formData: FormData) {
        let file: FormData = formData;
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addaffiliateInformation));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliatedetail/addupdateaffiliate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteAffiliateById(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/delete/" + affiliateid;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public deleteContractVideoById(contractVideoId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatecontractvideo/deleteaffiliatecontractvideo/" + contractVideoId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }



    // public addUpdateAffiliateByPopUp(affiliateInformationDc :AffiliateInformationDc) {

    public addAffiliateByPopup(addaffiliateInformation: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliate/addaffiliatebypopup";
        return this._httpHelper.post(environment.APIBaseUrl + url, addaffiliateInformation, reqOption);
    }


    public updateAffiliateTeamMember(addaffiliateInformation: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affportal/teammember/update";
        return this._httpHelper.put(environment.APIBaseUrl + url, addaffiliateInformation, reqOption);
    }

    public getAffiliatePersonalInformationById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliateinformation/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    ///////////////// Affiliate Task Service ////////////


    public getAffiliateTaskById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliatetask/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateTaskListByAffiliateId(searchAffiliateTaskDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliatetask/tasklistbyaffiliateid/";
        return this._httpHelper.post(environment.APIBaseUrl + url, searchAffiliateTaskDc, reqOption);
    }

    public addAffiliateTask(affiliateTaskDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliatetask/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, affiliateTaskDc, reqOption);
    }

    public deleteAffiliateTaskById(affiliatetaskId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/affiliatetask/deletaffiliatetask/" + affiliatetaskId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ///////////////////////////////////////////////////
    //  AddUpadate Affiliate      //
    //////////////////////////////////////////////////


    public addUpdateAffiliatePortalInfo(affiliatePortalInformationDc: AffiliatePortalInformationDc) {
        let file: FormData = affiliatePortalInformationDc.AffiliateLogo;
        affiliatePortalInformationDc.AffiliateLogo = "";
        affiliatePortalInformationDc.AffiliatePicture = "";
        affiliatePortalInformationDc.SidekickesLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(affiliatePortalInformationDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/affiliateportalinformation/addupdateaffiliateportalinfo"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getAffiliatePortalInfoByAffiliateId(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/affiliateportalinformation/details/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    ////////////////////////////////////////
    //            Banner                  //
    /////////////////////////////////////////
    public getAffiliatePortalBannerListByAffiliateId(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/List/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliatePortalBannerByportalId(clientbannerportalid: Number) {

        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/details/" + clientbannerportalid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addAffiliatePortalBanner(clientBannerDc: ClientBannerDc) {
        let file: FormData = clientBannerDc.ClientPortalBannerLogo;
        clientBannerDc.ClientPortalBannerLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(clientBannerDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public updatePortalBannerFromAffPortal(clientBannerDc: ClientBannerDc) {
        let file: FormData = clientBannerDc.ClientPortalBannerLogo;
        clientBannerDc.ClientPortalBannerLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(clientBannerDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/updatebannerfromaffportal"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public updateLogoPreviewFromAffPortal(affiliatePortalInformationDc: AffiliatePortalInformationDc) {
        let file: FormData = affiliatePortalInformationDc.AffiliateLogo;
        affiliatePortalInformationDc.AffiliateLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(affiliatePortalInformationDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/updatelogopreviewfromaffportal"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public updateSidekickePreviewFromAffPortal(affiliatePortalInformationDc: AffiliatePortalInformationDc) {
        let file: FormData = affiliatePortalInformationDc.SidekickesLogo;
        affiliatePortalInformationDc.SidekickesLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(affiliatePortalInformationDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportalbanner/updatesidekickpreviewfromaffportal"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    //////////////////////////////////////
    // Portal logo                       //
    //////////////////////////////////////

    public getAffiliatePortalLogoListByAffiliateId(affiliateid: Number) {

        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportallogo/List/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliatePortalLogoByPortalId(clientportalid: Number) {

        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportallogo/details/" + clientportalid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addAffiliatePortalLogo(clientPortalLogoDc: ClientPortalLogoDc) {
        let file: FormData = clientPortalLogoDc.ClientPortalLogoImage;
        clientPortalLogoDc.ClientPortalLogoImage = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(clientPortalLogoDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliateclient/clientportallogo/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }
    //
    ///////////////////////////////////
    //    Affiliate By Business        //
    /////////////////////////////////////
    public getAffiliateDetailByBusiness() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        //let url = "affiliate/affiliatetype/getAffiliateByBusinessId";
        let url = `affiliate/affiliatetype/getaffiliatesbytype?typeId=${AffiliateTypeId.Business}&employeeId=${SessionHelper.getUserId()}&affiliateId=0`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    /////////////////////////////////////
    //       Affiliate By Team         //
    /////////////////////////////////////


    public getAffiliateDetailByTeam(affiliateid: Number = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = '';
        url = `affiliate/affiliatetype/getaffiliatesbytype?typeId=${AffiliateTypeId.TeamLead}&employeeId=${SessionHelper.getUserId()}&affiliateId=${affiliateid}`;
        if (affiliateid != 0) {
            url = "affiliate/affiliatetype/getaffiliatebyteamid/" + affiliateid;
        }
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    ////////////////////////////////////////
    //         Affiliate Statictes          //
    ///////////////////////////////////////
    public getAffiliateStatisticsDetailsByAffiliateId(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatesnapshot/affiliate/getaffiliatestatisticsbyid/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    ///////////////////////////////////////
    public getAffiliateStatisticsDetails(affiliateIdsList: string, userId: any = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatesnapshot/affiliate/getaffiliatestatisticsonaffiliateportal?AffiliateIdsList=" + affiliateIdsList + "&UserId=" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    ///////////////////get Top 5 Note list on affiliate portal
    public getTopFiveNoteListByAffiliateId(affiliateIdsList: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/noteattachment/gettopfivenotebyaffiliateid?AffiliateIdsList=" + affiliateIdsList;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateLastLeadDetailByAffiliateId(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatesnapshot/affiliate/getlastleadsentandlastleadregbyaffiliateid/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    ///////////////////////////////////// Affiliate By Team   /////////////////////////////////////
    //For Business login Show Team List For Affiliate Portal
    public getAllBusinessTeamListForAffiliatePortal(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/getbusinessteamlistforaffiliateportal/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //For Business login Show Member List For Affiliate Portal
    public getAllGetBusinessMemberListForAffiliatePortal(CompanyId: Number, TeamId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/getbusinessmemberlistforaffiliateportal?companyid=" + CompanyId + "&teamid=" + TeamId;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }
    //For TeamLead login Show Member List For Affiliate Portal
    public getAllTeamLeadMemberListForAffiliatePortal(TeamId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/getteamleadmemberlistforaffiliateportal/" + TeamId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // ///////////////////get common Note list on affiliate portal
    // public getCommonAffiliateNoteListByAffiliateId(affiliateId: string) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "affiliate/communication/noteattachment/getallnotefromaffiliateportal?affiliateId=" + affiliateId;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }
    ///////////////affliate Communication
    public getContactAccociatedByAffiliateId(affiliateIdsList: string, userId: Number = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/getcontactassociatedbyaffilaiteid?affiliateIdsList=" + affiliateIdsList + "&UserId=" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAffiliateNoteAttachment(AffiliateCommunicationNoteDc: any) {
        let file: FormData = AffiliateCommunicationNoteDc.AttachmentFile;
        AffiliateCommunicationNoteDc.AttachmentFile = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(AffiliateCommunicationNoteDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/communication/noteattachment/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    // public getAffiliateNoteListByAffiliateId(affiliateid: Number) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "affiliate/communication/noteattachment/details/" + affiliateid;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }
    ///////////////////get common Note list on affiliate portal
    public getCommonAffiliateNoteListByAffiliateId(affiliateId: string, pageNo: Number = 1, pageSize: Number = 10) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/noteattachment/getaffiliatenotefromcrmportal?affiliateId=" + affiliateId + "&pageno=" + pageNo + "&pagesize=" + pageSize;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactNotesByAffiliateId(affiliateId: string, pageNo: Number = 1, pageSize: Number = 10) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/communication/noteattachment/getcontactnotesbyaffiliateid?affiliateId=" + affiliateId+"&pageno="+pageNo+"&pagesize="+pageSize;
        let url = "affiliate/communication/noteattachment/getcontactnotesbyaffiliateid?affiliateId=" + affiliateId + "&pageno=" + pageNo + "&pagesize=" + pageSize;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteAffiliateNoteListByAffiliateId(affiliateid: Number, TBName: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/noteattachment/deletefromcrmportal?affiliateid=" + affiliateid + "&tablename=" + TBName;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public MarkedNoteImportant(NoteId: Number, IsImportant: boolean) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/communication/noteattachment/markimportant?noteid=" + NoteId + "&isimportant=" + IsImportant;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }

    public hideShowNoteToAffPortal(noteId: Number, communicationType: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "dashboard/deletecommunication?Noteid=" + noteId + "&CommunicationType=" + communicationType;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    // ///////////////////get common Note list on affiliate portal
    // public getCommonAffiliateNoteListByAffiliateId(affiliateid: Number) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "affiliate/communication/noteattachment/getallnotefromaffiliateportal/" + affiliateid;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }


    ////////////////////// My Referrals //////////////////////////////////////////////////
    public getReferralsDetailsByAffiliateId(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "Affiliate/referrals/getreffrallistoncrmportal/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getReferralsDetailsByAffiliateIdList(affiliateIdsList: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "Affiliate/referrals/detailsbyaffiliateId?affiliateIdsList=" + affiliateIdsList;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public DeleteReferralsDetailsById(referralsid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "Affiliate/referrals/delete/" + referralsid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ////////////////////// For Contact add //////////////////////////////////////////////////

    public addContactByPopup(addContactPersonalInformation: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactpersonalinformation/addcontactbypopup"
        return this._httpHelper.post(environment.APIBaseUrl + url, addContactPersonalInformation, reqOption);
    }

    //////////////////////// Associated Contacts /////////////////////////////////////////////////////////////
    public GetAssociatedContactsListByAffiliateId(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/associatedcontacts/getalllist/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);

    }

    // public getMyReferralsByAffiliateId(affiliateId: Number) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "affiliate/myreferrals/getassocaitedcontactlistbyaffiliateid/" + affiliateId;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }
    public getMyReferralsByAffiliateId(affiliateIdsList: string, pageNo: Number, currentTab: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/myreferrals/alldetails?affiliateIdsList=" + affiliateIdsList;
        let url = "affiliate/myreferrals/alldetails?affiliateIdsList=" + affiliateIdsList
            + "&pageno=" + pageNo
            + "&contactTypeId=" + currentTab + "&pagesize=" + 5;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerCreditScore(contactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/creditscore/" + contactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    ////////////////////////////////Messages Master //////////////////////////////////////////////
    public getOnlyActivMessagesList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/messagesmaster/bindmessages"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    /////////////////////////////////Affiliate my Profile///////////////
    public getAffiliateMyProfileDetailById(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/affiliateprofiledetails/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);

    }

    /////////////////////////////////Affiliate Logo Bannner///////////////
    public getAffiliateLogoBannner(affiliateid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/getaffiliatelogobanner/" + affiliateid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);

    }

    /////////////////////////////////Update Affiliate Profile Detail///////////////
    public updateAffiliateProfileDetail(AffiliateMyProfileDc: any, formData?: FormData) {
        let file: FormData = formData;
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(AffiliateMyProfileDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliate/updateaffiliateprofiledetail"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    /////////////////////////////////contact list without advance search////////
    public getAllAffiliatePageDropdownLists() {
        const user = SessionHelper.getUser();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/getaffiliatepagedropdownlists";
        let url = `affiliate/getaffiliatepagedropdownlistsbyuser?userId=${user.UserId}&userType=${user.UserType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    /////////////////////////////////Get Team List by Business///////////////
    public getAllTeamListByBusinessId(companyId: any = 0, programId: any = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/getteamlistbybusinessid/" + companyId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    /////////////////////////////////Set Affiliate Module Permission///////////////
    public setAffiliatePermission(permission) {
        this.affiliatePermission = permission;
    }

    /////////////////////////////////Get Affiliate Module Permission///////////////
    public getAffiliateModulePermission() {
        let userProfileDetail = this.employeeService.getUserProfileDetail();
        let roleId = (userProfileDetail) ? userProfileDetail.RoleId : SessionHelper.getUserRoleId();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `permission/getsubmodules?roleId=${roleId}&moduleName=${ModuleNameConstant.Affiliate}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    ////////////////////////////////Get User Assigned Affiliates///////////////
    public getOnlyMyAffiliates(affliateList = []) {
        let currentUserId = SessionHelper.getUserId();
        return affliateList.filter(x => (x.MarketerId == currentUserId || x.RelationshipManagerId == currentUserId));
    }

    ////////////////////////////////Get User Assigned + Same Program Affiliates///////////////
    public getSameProgramAffiliates(affliateList = []) {
        let userProfileDetail = this.employeeService.getUserProfileDetail();
        return affliateList.filter(x => ((x.RelationshipManagerId == userProfileDetail.EmployeeId || x.MarketerId == userProfileDetail.EmployeeId) || (userProfileDetail.ProgramIds && userProfileDetail.ProgramIds.includes(x.ProgramId))));
    }

    ////////////////////////////////Update Multiple Affiliate Details///////////////
    public updateMultipleAffiliates(affiliateGroupUpdateInformation: AffiliateGroupUpdateInformation) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/affiliategroupupdate";
        return this._httpHelper.put(environment.APIBaseUrl + url, affiliateGroupUpdateInformation, reqOption);
    }

    /////Contact Column Hide Show Detail
    public getAffiliateColumnHideShowDetailById(employeeid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliatecolumnhideshowdetail/details/" + employeeid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public addAffiliateColumnHideShowDetail(affiliateHideShowColumnDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliatecolumnhideshowdetail/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, affiliateHideShowColumnDc, reqOption);
    }

    public getAffiliateGoals() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/crgoal/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateTeamCardVideoUrl(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatevideo/getaffiliatevideo?AffiliateId=" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateSideKickLogo(AffiliateMyProfileDc, formData: FormData) {
        let file: FormData = formData;
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(AffiliateMyProfileDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/affiliate/updatesidekickslogo"
        return this._httpHelper.putFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteSideKickesLogo(AffiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliateclient/affiliateportalinformation/deletesidekickesLogo/" + AffiliateId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getallRelationships() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "relationshipmaster/getallrelationships";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getEducationalVideoList(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/educationvideo/getaffeducationalvideos/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getAffiliateEducationalVideoList(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/educationvideo/getaffeducationalvideosCAM/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public AddUpdateAffiliateEducationalVideoDetails(addAffiliateEducationalVideoDc: AffiliateEducationalVideoDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/educationvideo/addupdatedetails"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAffiliateEducationalVideoDc, reqOption);
    }


    public onPauseOrUnpauseAffVideos(pausedOrUnpausedAffVideos) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/educationvideo/pauseorunpauseaffvideos";
        return this._httpHelper.putFile(environment.APIBaseUrl + url, pausedOrUnpausedAffVideos, reqOption);
    }

    public updateContactFromAffPortal(contactInformationDc: MyReferralsDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "Affiliate/referrals/updatecontactfromaffPortal"
        return this._httpHelper.put(environment.APIBaseUrl + url, contactInformationDc, reqOption);
    }

    public sendContractFromAffPortal(data) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "Affiliate/referrals/sendcontractfromaffPortal"
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public getFirstAndMostVideoaAddedDate(affiliateId: Number): Observable<AffiliateFirstAndMostRecentlyVideo> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/educationvideo/getfirstandmostvideoaddeddate/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmailQueueDetails(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailqueue/affiliate/details/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public saveEmailQueueDetails(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "emailqueue/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    // add affiliate portal task and notes
    // public addAffiliatePortalNote(addAffiliatePortalNoteDc: AffiliateNotesDc) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    //     let url = "affportal/note/add"
    //     return this._httpHelper.post(environment.APIBaseUrl + url, addAffiliatePortalNoteDc, reqOption);
    // }

    public addAffiliatePortalTask(addAffiliatePortalTaskDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affportal/task/add"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAffiliatePortalTaskDc, reqOption);
    }

    public refreshEducationPage(isRefresh: boolean) {
        this.refreshEducationVideo.next(isRefresh);
    }

    public getEmailTemplates(userId: Number, userType: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `emailtemplate/bindemailtemplatebycondition?userId=${userId}&userType=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteEmail(emailId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailsenthistory/delete/" + emailId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateByProgramAndIndustryid() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliate/affiliatebyprogramandindustryid";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    changeContactId(contactId: any) {
        this.contactIdSource.next(contactId);
    }

    // public verifyDuplicateEmail(emailAddress: string){
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
    //     let url = `user/IsEmailAlreadyInUse?Email=${emailAddress}`;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }

    getAffiliateAltGoals(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `affiliatealtgoal/getaffiliatealtgoals/${affiliateId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    saveAffiliateAltGoals(afffiliateAltGoals: Array<any>) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliatealtgoal/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, afffiliateAltGoals, reqOption);
    }

    deleteAffiliateVideo(videoId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliatevideo/deleteaffvideo/" + videoId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getQRCode(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatesqr/getsqrcode/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public generateQRCode(affiliateId: Number) {
        const data = {
            "AffiliateId": affiliateId
        };
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatesqr/createsqrcode";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }


    dowloadQRCode(url: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this._httpHelper.downloadFile(url, reqOption);
    }

    updateTeamTrackingLink(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/affiliatedetail/updateteamtrackinglink";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/services/affiliate.service.ts